<template>
  <div class="ThemeQuestion" @click="randomizeQuestion" >

      {{question}}

    <!--div class="newQuestion">
      Klicka för ny fråga
    </div-->

  </div>
</template>

<script>

//import { mapGetters } from 'vuex'
//const { mapState } = createNamespacedHelpers('namespace1/namespace2')

export default {
  name: 'ThemeQuestion',
  components: {
    //Component
  },
  data: function () {
    return {
      question: ""
    }
  },
  props: {
    theme: Object
  },
  computed: {
  },
  methods: {
    randomizeQuestion: function () {
      this.question = this.theme.getRandomQuestion()
    }
  },
  mounted: function () {
    this.randomizeQuestion();
  },
  created: function () {
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.ThemeQuestion{
  position: relative;
  background: var(--color);
  padding: 10px;
  text-align: center;
  cursor: pointer;
  color: white;
  font-family: var(--font-header);
  font-size: large;
}

h4{
  margin: 0;
  font-weight: bold;
  color: white;
}

.newQuestion{
  position: absolute;
  right: 10px;
  bottom: 10px;
  color:white;
}

</style>
